import React, { useState } from "react"
import { Form, Modal, ModalBody, ModalHeader } from "reactstrap"
import axios from "axios"
import { useHistory } from "react-router-dom"

const DeleteRD6Report = ({
  deleteReportToggle,
  deleteReportModal,
  selectedItem,
  editing,
  setEditing,
  setAuth,
}) => {
 
  const history = useHistory()


  const onClose = () => {
    deleteReportToggle()
  }

  // *********************** Submit handler ******************************** //
  const submitHandler = e => {
    e.preventDefault()

    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      RD6ID: selectedItem.RD6ID,
      Deleted: "1",
    }
    // console.log("formData", formData)

    axios
      .post(        
        process.env.REACT_APP_API_URL+"api/RD6/EditRD6.php",
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }
        onClose()
        // console.log(res)
        setEditing(!editing)
      })
      .catch(err => console.log(err))

 
  }

  return (
    <Modal isOpen={deleteReportModal} toggle={deleteReportToggle} className="modal-md">
      <ModalHeader>
        Delete RD6 Report
        <button
          type="button"
          className="btn-close position-absolute end-0 top-0 m-3"
          onClick={onClose}
        />
      </ModalHeader>

      <ModalBody className="px-4 py-3 text-center">
        <Form onSubmit={submitHandler}>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-trash-can-outline"></i>
            </div>
          </div>
          <p className="font-size-16 mb-4">
            Are You Sure You Want To Permanently <br/>Delete <span className="text-warning h5">{selectedItem.RD6ID}</span> Report ?
          </p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
            <button type="submit" onClick={submitHandler} className="btn btn-danger">
              Delete Now
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default DeleteRD6Report
